import utils from '../utils'
import axios from 'axios'
import qs from 'qs'
import md5 from 'blueimp-md5'

// 应用id
let specialAppConfig = {
  id: '9d7f7c7c-f9f1-11e8-b384-5254004b0a40',
  secret: 'd9f76a27d9b83f4df8d21c4ae27d5e40'
}

export default function (options) {
  if (!utils.isObj(options)) {
    console.log('埋点数据不正确')
    return
  }
  let requestHeader = {
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
  }
  let time = utils.timeFormat('yyyyMMddhhmmss')
  let secretKey = md5(`${time}${specialAppConfig.secret}`)
  // 获取用户信息，用户user_id,用户类型user_type
  let userMsg = JSON.parse(localStorage.getItem('user_message')) || {userId: '000000', userType: '体验用户'}
  let referer = document.referrer
  let refererSource = utils.getQueryString('source', referer)
  let source = utils.getQueryString('source') || refererSource || ''

  // 需要在html文件中插入 https://pv.sohu.com/cityjson?ie=utf-8
  let ipaddr = utils.isObj(window.returnCitySN) ? window.returnCitySN.cip : ''
  let logData = {
    json_data: {},
    app_id: specialAppConfig.id,
    rtoken: secretKey,
    time: time,
    v: '1.0',
    ipaddr: ipaddr,
    client: 'H5',
    module: '2019第十二届烟台国际葡萄酒博览会报名',
    sub_module: '',
    op_event: '',
    source: source,
    channel: utils.getQueryString('channel'),
    wine_id: '', // 商品id
    query_word: '',
    year: '', // 商品年份
    access_url: '',
    geo_location: '', // 经纬度
    query_column: location.href, // 来源页面
    useragent: navigator.userAgent,
    // 用户信息
    user_id: userMsg.userId,
    user_type: userMsg.userType
  }

  logData = Object.assign(logData, options)

  console.log('日志提交信息', logData)

  if (process.env.NODE_ENV === 'development') {
    console.log('测试环境下不提交kacha日志')
    return
  }

  return new Promise((resolve, reject) => {
    axios({
      url: 'https://logger.9kacha.com/record_log.php',
      data: qs.stringify({jparams: JSON.stringify(logData)}),
      ...requestHeader
    })
      .then(res => {
        if (res.data.status === 0) {
          console.log('提交日志成功')
          resolve()
        }
      })
      .catch(err => {
        console.log('提交日志发生错误', err)
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/userBehaviorLogs.js